import { render, staticRenderFns } from "./XCurrencyTextField.vue?vue&type=template&id=0981bfa2"
import script from "./XCurrencyTextField.vue?vue&type=script&lang=js"
export * from "./XCurrencyTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0981bfa2')) {
      api.createRecord('0981bfa2', component.options)
    } else {
      api.reload('0981bfa2', component.options)
    }
    module.hot.accept("./XCurrencyTextField.vue?vue&type=template&id=0981bfa2", function () {
      api.rerender('0981bfa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/HyperionX/UIComponents/XCurrencyTextField.vue"
export default component.exports